import React from "react";
import { Button } from "@mui/material";

const VerificationPage = () => {
  return (
    <div className="tw-min-h-screen tw-flex">
      {/* Left Section */}
      <div className="lg:tw-w-3/4 md:tw-w-2/4 sm:tw-w-full tw-hidden login-bg tw-bg-cover tw-bg-center sm:tw-flex tw-items-end tw-justify-start tw-text-white tw-p-14">
        <div className="tw-px-4">
          <h1 className="tw-font-bold font-size-5xl tw-mb-4 tw-leading-[74px]">
            Innovative Collateral & <br /> Risk Solutions
          </h1>
        </div>
      </div>

      {/* Right Section */}
      <div className="lg:tw-w-1/4 md:tw-w-2/4 sm:tw-w-full tw-w-full tw-flex tw-items-center tw-justify-center">
        <div className="tw-w-full tw-max-w-md tw-px-6">
          {/* Logo and Instructions */}
          <div className="tw-mb-8">
            <img
              src="/logo/Logo.svg"
              alt="Logo"
              className="tw-mx-auto tw-max-w-[150px] tw-mb-14"
            />
            <h6 className="font-primary font-primary-color tw-text-[22px] font-weight-semibold tw-leading-6">
              Email verified successfully!
            </h6>
            <p className="tw-mt-2 tw-leading-6 font-size-sm font-gray-color font-weight-medium">
              Email verified successfully! Now, let’s secure your account by
              verifying your phone number.
            </p>
          </div>

          {/* Verify Button */}
          <Button
            fullWidth
            variant="contained"
            className="tw-py-2 primary-custom-button"
          >
            Go To Dashboard
          </Button>
        </div>
      </div>
    </div>
  );
};

export default VerificationPage;
